var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAcceptRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.898,
    height: 45.639,
    viewBox: "0 0 62.898 45.639",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "76.325%",
    x2: "0%",
    y2: "23.675%",
    id: "ky2fhpw2la"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.82 0h17.259c12.603 0 22.82 10.217 22.82 22.82s-10.217 22.82-22.82 22.82h-17.26C10.218 45.64 0 35.422 0 22.82S10.217 0 22.82 0z",
    stroke: "url(#ky2fhpw2la)",
    strokeWidth: 1.29,
    fill: "#000",
    fillRule: "nonzero",
    transform: "rotate(-180 31.45 22.82)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7AEACD",
    strokeWidth: 3.148,
    strokeLinecap: "round",
    d: "m22.643 22.712 5.79 5.813 11.364-11.41"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAcceptRequest);
export default __webpack_public_path__ + "static/media/ic_accept_request.91ab5164ccbfadbda2bd84e5407c989c.svg";
export { ForwardRef as ReactComponent };